exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#trackList{width:960px;overflow-x:scroll}.buttonFields{display:flex;flex-direction:row}.field-data-head{display:flex;flex-direction:column;width:178px;padding:2px;text-align:right;border:1px solid #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59cf5938","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DataList.vue
// module id = 24
// module chunks = 0